import {
  ClickAwayListener,
  Tooltip,
  TooltipProps,
  useTheme,
} from '@mui/material';
import { MouseEvent, PointerEvent, useState } from 'react';

interface Props {
  title: TooltipProps['title'];
  children: TooltipProps['children'];
  stopClickPropagation?: boolean;
}

const InfoTooltip = ({ title, children, stopClickPropagation }: Props) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const handleClick = (e: PointerEvent<HTMLDivElement>) => {
    if (e.pointerType !== 'touch') {
      return;
    }
    handleStopPropagation(e);
    setOpen((open) => !open);
  };

  const handleStopPropagation = (e: MouseEvent) => {
    if (!stopClickPropagation) {
      return;
    }
    e.stopPropagation();
  };

  return (
    <ClickAwayListener onClickAway={() => open && setOpen(false)}>
      <Tooltip
        arrow={true}
        placement="top"
        onClick={handleStopPropagation}
        onPointerDown={handleClick}
        open={open}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        componentsProps={{
          tooltip: {
            sx: { maxWidth: '90vw' },
          },
        }}
        title={title}
      >
        {children}
      </Tooltip>
    </ClickAwayListener>
  );
};

export default InfoTooltip;
